import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=311b8b83&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=311b8b83&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311b8b83",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('311b8b83')) {
      api.createRecord('311b8b83', component.options)
    } else {
      api.reload('311b8b83', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=311b8b83&scoped=true&", function () {
      api.rerender('311b8b83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4dv7gdcxsWW8y/JS/comp/CookieBox.vue"
export default component.exports